import * as React from 'react'
import { shallow } from 'enzyme'
import { Input as StyledInput, Label } from '../../TextInput/styles'
import { TextInput } from '../../TextInput/index'

const TEST_VALUE = 'TEST_VALUE'
describe('Input', () => {
  let input
  beforeAll(() => {
    input = shallow(<TextInput value={TEST_VALUE} />)
  })
  beforeEach(() => jest.clearAllMocks())
  it('set value', () => {
    input.setProps({ value: TEST_VALUE })
    expect(input.find(StyledInput).prop('value')).toBe(TEST_VALUE)
  })

  it('set placeholder', () => {
    input.setProps({ placeholder: TEST_VALUE })
    expect(input.find(Label)).toHaveText(TEST_VALUE)
  })

  it('set empty', () => {
    input.setProps({ value: '' })
    expect(input.find(Label).prop('isEmpty')).toBeTruthy()
  })

  it('set invalid', () => {
    expect(input.find(StyledInput).prop('invalid')).toBeFalsy()
    input.setProps({ invalid: true })
    expect(input.find(StyledInput).prop('invalid')).toBeTruthy()
  })
})
